import fp from "lodash/fp";

import { mapDomainsFromBackEnd } from "helpers";
import { withResetState } from "store/hocs";

import { agentOfficeSetupConstants } from "./agentOfficeSetup.constants";

const initialState = {
	error: null,
	agentOfficeList: [],
	sort: {
		column: "officeName",
		ascending: true,
	},
	primaryContact: [],
	count: 0,
	page: 0,

	loading: false,
	isLoadingAgent: false,
	additionalFeeTemplateLoading: false,
	monthlyFeeTemplatesLoading: false,
	feeTemplatesLoading: true,
	loadingForm: false,

	editAgentOfficeForm: [],
	ingestTsysForm: {},
	ingestFiservForm: {},
	agents: [],
	merchantList: [],
	isMerchantAriseSyncEnabled: false,
	notificationTemplates: [],
	eSignAccounts: [],

	tsysCredentials: [],
	ftCredentials: [],

	additionalFeeTemplate: [],
	monthlyFeeTemplate: [],
	feeTemplates: {
		"Interchange Plus": [],
		"Flat Rate": [],
		"3-Tier": [],
		ERR: [],
	},
};

function agentOfficeSetup(state = initialState, action) {
	switch (action.type) {
		case agentOfficeSetupConstants.GET_AGENT_OFFICES_REQUEST:
			return {
				...state,
				loading: true,
				page: action.page,
				sort: {
					...action.sort,
				},
			};
		case agentOfficeSetupConstants.GET_AGENT_OFFICES_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				agentOfficeList: action.agentOffice.items,
				count: action.agentOffice.count,
			};
		case agentOfficeSetupConstants.GET_AGENT_OFFICES_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error,
			};

		case agentOfficeSetupConstants.SET_STATUS_FAILURE: {
			return {
				...state,
				error: action.error,
			};
		}
		case agentOfficeSetupConstants.GET_PRIMARY_CONTACT_SUCCESS: {
			return {
				...state,
				primaryContact: action.primaryContact.users,
				loading: false,
			};
		}
		case agentOfficeSetupConstants.GET_PRIMARY_CONTACT_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case agentOfficeSetupConstants.EDIT_AGENT_OFFICE_DOCUMENT_REQUEST:
			return {
				...state,
				isLoadingAgent: true,
				loading: true,
			};
		case agentOfficeSetupConstants.EDIT_AGENT_OFFICE_DOCUMENT_SUCCESS: {
			const whitelistedEmailDomains = mapDomainsFromBackEnd(
				action.editAgentOfficeForm?.whitelisted_email_domains,
			);
			const editAgentOfficeForm = {
				...action.editAgentOfficeForm,
				whitelistedEmailDomains,
				parentOfficeName:
					action.editAgentOfficeForm.parentOfficeName || "No Parent",
			};
			delete editAgentOfficeForm.whitelisted_email_domains;

			return {
				...state,
				editAgentOfficeForm,
				isLoadingAgent: false,
				loading: false,
			};
		}
		case agentOfficeSetupConstants.GET_AGENTS_SUCCESS:
			return {
				...state,
				agents: action.agents,
			};
		case agentOfficeSetupConstants.GET_AGENTS_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case agentOfficeSetupConstants.GET_MERCHANT_LIST_SUCCESS:
			return {
				...state,
				merchantList: action.merchantList,
				isMerchantAriseSyncEnabled: action.isAriseSyncEnabled,
			};
		case agentOfficeSetupConstants.GET_MERCHANT_LIST_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case agentOfficeSetupConstants.GET_NOTIFICATION_TEMPLATES_SUCCESS:
			return {
				...state,
				notificationTemplates: action.notificationTemplates,
			};
		case agentOfficeSetupConstants.GET_NOTIFICATION_TEMPLATES_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case agentOfficeSetupConstants.GET_E_SIGN_ACCOUNTS_SUCCESS:
			return {
				...state,
				eSignAccounts: action.eSignAccounts,
			};
		case agentOfficeSetupConstants.GET_E_SIGN_ACCOUNTS_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		case agentOfficeSetupConstants.GET_EDIT_MONTHLY_FEE_DOCUMENTS_REQUEST:
			return {
				...state,
				monthlyFeeTemplatesLoading: true,
			};
		case agentOfficeSetupConstants.GET_EDIT_MONTHLY_FEE_DOCUMENTS_SUCCESS:
			return {
				...state,
				monthlyFeeTemplate: action.feeTemplates,
				monthlyFeeTemplatesLoading: false,
			};
		case agentOfficeSetupConstants.GET_EDIT_MONTHLY_FEE_DOCUMENTS_ERROR:
			return {
				...state,
				error: action.error,
				monthlyFeeTemplatesLoading: false,
			};
		case agentOfficeSetupConstants.GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_REQUEST:
			return {
				...state,
				additionalFeeTemplateLoading: true,
			};
		case agentOfficeSetupConstants.GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_SUCCESS:
			return {
				...state,
				additionalFeeTemplate: action.feeTemplates,
				additionalFeeTemplateLoading: false,
			};
		case agentOfficeSetupConstants.GET_EDIT_ADDITIONAL_FEE_DOCUMENTS_ERROR:
			return {
				...state,
				error: action.error,
				additionalFeeTemplateLoading: false,
			};
		case agentOfficeSetupConstants.CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_REQUEST:
			const changeStatusRequestAdditionalFeeTemplates = [
				...state.additionalFeeTemplate,
			];
			fp.flow(fp.find(x => x.id === action.templateId))(
				changeStatusRequestAdditionalFeeTemplates,
			).active = action.active;

			return {
				...state,
				additionalFeeTemplate:
					changeStatusRequestAdditionalFeeTemplates,
			};
		case agentOfficeSetupConstants.CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_SUCCESS:
			return {
				...state,
			};
		case agentOfficeSetupConstants.CHANGE_ADDITIONAL_FEE_TEMPLATE_STATUS_ERROR:
			const changeStatusErrorAdditionalFeeTemplates = [
				...state.additionalFeeTemplate,
			];
			fp.flow(fp.find(x => x.id === action.templateId))(
				changeStatusErrorAdditionalFeeTemplates,
			).active = action.active;

			return {
				...state,
				error: action.error,
				additionalFeeTemplate: changeStatusErrorAdditionalFeeTemplates,
			};
		case agentOfficeSetupConstants.CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_REQUEST:
			const changeStatusRequestMonthlyFeeTemplates = [
				...state.monthlyFeeTemplate,
			];
			fp.flow(fp.find(x => x.id === action.templateId))(
				changeStatusRequestMonthlyFeeTemplates,
			).active = action.active;

			return {
				...state,
				monthlyFeeTemplate: changeStatusRequestMonthlyFeeTemplates,
			};
		case agentOfficeSetupConstants.CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_SUCCESS:
			return {
				...state,
			};
		case agentOfficeSetupConstants.CHANGE_MONTHLY_FEE_TEMPLATE_STATUS_ERROR:
			const changeStatusErrorMonthlyFeeTemplates = [
				...state.monthlyFeeTemplate,
			];
			fp.flow(fp.find(x => x.id === action.templateId))(
				changeStatusErrorMonthlyFeeTemplates,
			).active = action.active;

			return {
				...state,
				error: action.error,
				monthlyFeeTemplate: changeStatusErrorMonthlyFeeTemplates,
			};
		case agentOfficeSetupConstants.GET_FEE_TEMPLATES_REQUEST:
			return {
				...state,
				feeTemplatesLoading: true,
			};
		case agentOfficeSetupConstants.GET_FEE_TEMPLATES_SUCCESS:
			return {
				...state,
				feeTemplates: {
					...initialState.feeTemplates,
					...fp.groupBy(x => x.type, action.feeTemplates),
				},
				feeTemplatesLoading: false,
			};
		case agentOfficeSetupConstants.GET_FEE_TEMPLATES_ERROR:
			return {
				...state,
				error: action.error,
				feeTemplatesLoading: false,
				feeTemplates: initialState.feeTemplates,
			};

		case agentOfficeSetupConstants.REODER_FEE_TEMPLATES_REQUEST:
			return {
				...state,
				feeTemplates: {
					...state.feeTemplates,
					[action.templateType]: action.reorderedTemplates,
				},
			};
		case agentOfficeSetupConstants.REODER_FEE_TEMPLATES_SUCCESS:
			return {
				...state,
			};
		case agentOfficeSetupConstants.REODER_FEE_TEMPLATES_ERROR:
			return {
				...state,
				error: action.error,
				feeTemplates: {
					...state.feeTemplates,
					[action.templateType]: action.orderedTemplates,
				},
			};
		case agentOfficeSetupConstants.CHANGE_FEE_TEMPLATE_STATUS_REQUEST:
			const changeStatusRequestFeeTemplates = {
				...state.feeTemplates,
			};
			fp.flow(
				fp.flatMap(x => x),
				fp.find(x => x.id === action.templateId),
			)(changeStatusRequestFeeTemplates).active = action.active;

			return {
				...state,
				feeTemplates: changeStatusRequestFeeTemplates,
			};
		case agentOfficeSetupConstants.CHANGE_FEE_TEMPLATE_STATUS_SUCCESS:
			return {
				...state,
			};
		case agentOfficeSetupConstants.CHANGE_FEE_TEMPLATE_STATUS_ERROR:
			const changeStatusErrorFeeTemplates = {
				...state.feeTemplates,
			};
			fp.flow(
				fp.flatMap(x => x),
				fp.find(x => x.id === action.templateId),
			)(changeStatusErrorFeeTemplates).active = action.active;

			return {
				...state,
				error: action.error,
				feeTemplates: changeStatusErrorFeeTemplates,
			};

		case agentOfficeSetupConstants.GET_TSYS_CREDENTIALS_REQUEST:
			return {
				...state,
				loading: true,
			};
		case agentOfficeSetupConstants.GET_TSYS_CREDENTIALS_SUCCESS:
			return {
				...state,
				tsysCredentials: action.tsysCredentials,
				loading: false,
			};
		case agentOfficeSetupConstants.GET_TSYS_CREDENTIALS_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};

		case agentOfficeSetupConstants.GET_FD_CREDENTIALS_REQUEST:
			return {
				...state,
				loading: true,
			};
		case agentOfficeSetupConstants.GET_FD_CREDENTIALS_SUCCESS:
			return {
				...state,
				ftCredentials: action.ftCredentials,
				loading: false,
			};
		case agentOfficeSetupConstants.GET_FD_CREDENTIALS_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};

		default:
			return state;
	}
}
export default withResetState({ initialState })(agentOfficeSetup);
